import React, { useContext } from 'react'
import ColorContext from '../../context/ColorContext'

const AppIcons = ({ style }) => {
	const { color } = useContext(ColorContext)
	return (
		<svg
			id="svgBrands"
			className="svgInline"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 225 255"
			style={style}
		>
			<linearGradient id="brandsGradient" gradientUnits="userSpaceOnUse" x1="37.4307" y1="290.3884" x2="281.4334" y2="51.7405" gradientTransform="matrix(1 0 0 -1 0 225.52)">
				<stop  offset="0" style={{ stopColor: color.bravo }} />
				<stop  offset="1" style={{ stopColor: color.alpha }} />
			</linearGradient>
			<path fill="url(#brandsGradient)" d="M103.7 103.7H0V0h103.7v103.7zM12.9 90.8h77.9V12.9H12.9v77.9z" />
			<path fill="url(#brandsGradient)" d="M225 225H121.3V121.3H225V225zm-90.8-12.9h77.9v-77.9h-77.9v77.9z" />
			<path fill="url(#brandsGradient)" d="M225 103.7H121.3V0h70.9L225 32.8v70.9zm-90.8-12.9h77.9V38.1l-25.2-25.2h-52.7v77.9z" />
			<path fill="url(#brandsGradient)" d="M70.9 121.3H0V225h103.7v-70.9l-32.8-32.8zm2.5 20.7 9.7 9.7h-9.7V142zm-60.5 70.1v-77.9h47.6v30.3h30.3v47.6H12.9z" />
			<path fill="url(#brandsGradient)" d="M141.8 202.9h62.6v-15l-14.6-16.7-23.3 19.7-13.5-8.1-11.2 12.6z" />
			<ellipse fill="url(#brandsGradient)" cx="165.5" cy="172.9" rx="7.6" ry="7.5" />
			<path fill="url(#brandsGradient)" d="M48.9 79.7v2.7H43V54.2h5.9v10.5c1.4-1.9 3.4-3.4 6.4-3.4 4.8 0 9.4 3.8 9.4 10.7v.1c0 6.9-4.5 10.7-9.4 10.7-3.1 0-5.1-1.4-6.4-3.1zm10-7.7c0-3.6-2.3-5.8-5.1-5.8-2.7 0-5 2.3-5 5.7v.1c0 3.5 2.3 5.7 5 5.7 2.7.1 5.1-2.2 5.1-5.7z" />
			<path fill="url(#brandsGradient)" d="M69 61.7h5.9v4.2c1.2-2.8 3.1-4.7 6.6-4.5v6.2h-.3c-3.9 0-6.3 2.4-6.3 7.3v7.6H69V61.7z" />
			<path fill="url(#brandsGradient)" d="M180.5 73.8c0-4.6 3.5-6.7 8.3-6.7 2.1 0 3.6.3 5.1.9v-.3c0-2.4-1.5-3.8-4.5-3.8-2.2 0-3.8.4-5.7 1.1l-1.5-4.5c2.3-1 4.5-1.7 8.1-1.7 3.2 0 5.5.9 7 2.3 1.6 1.6 2.2 3.8 2.2 6.6v12h-5.7v-2.2c-1.4 1.6-3.4 2.6-6.3 2.6-3.7.1-7-2.1-7-6.3zm13.6-1.4v-1c-1-.5-2.3-.8-3.7-.8-2.5 0-4.1 1-4.1 2.8v.1c0 1.6 1.3 2.5 3.2 2.5 2.7.1 4.6-1.5 4.6-3.6z" />
			<g>
				<path fill="url(#brandsGradient)" d="M36.9 184.3h5.9v2.9c1.4-1.8 3.1-3.3 6.1-3.3 4.5 0 7 2.9 7 7.7V205H50v-11.6c0-2.8-1.3-4.2-3.6-4.2-2.2 0-3.6 1.4-3.6 4.2V205h-5.9v-20.7z" />
				<path fill="url(#brandsGradient)" d="M60 194.7c0-7 4.5-10.8 9.4-10.8 3.1 0 5.1 1.4 6.4 3.1v-10.2h5.9V205h-5.9v-3c-1.4 1.9-3.4 3.4-6.4 3.4-4.8 0-9.4-3.8-9.4-10.7zm16 0c0-3.6-2.3-5.8-5-5.8s-5.1 2.2-5.1 5.7v.1c0 3.5 2.3 5.7 5.1 5.7 2.7.1 5-2.2 5-5.7z" />
			</g>

		</svg>
	)
}

export default AppIcons